<div class="icon-snack flex flex-1 flex-row items-center gap-[12px]">
  <mat-icon [ngClass]="data.iconClass">{{data.icon}}</mat-icon>
  <span class="flex flex-1">{{data.message}}</span>
  <button (click)="snackBarRef.dismiss()" mat-flat-button color="primary">Ok</button>
</div>
